// @ts-ignore
import axios from "axios";
import {WebAppUser} from "@twa-dev/types";
import WebApp from "@twa-dev/sdk";

function base64encode(str: string): string {
    let encode = encodeURIComponent(str).replace(/%([a-f0-9]{2})/gi, (_, $1) => String.fromCharCode(parseInt($1, 16)))
    return btoa(encode)
}

const tgInitDataBase64 = base64encode(process.env.REACT_APP_TG_INIT_DATA || WebApp.initData);

const apiUrl: string = process.env.REACT_APP_API_URL || "https://askerix.super-app.studio/api"

let ax = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Authorization': tgInitDataBase64
    },
    baseURL: apiUrl
})

export type Question = {
    question_id: number;
    from_user: WebAppUser|null;
    to_user: WebAppUser;
    question: string;
    created_at: string;
}

export interface Answer extends Question {
    answer: string;
    updated_at: string;
}

export type Profile = {
    user: WebAppUser;
    answers: Answer[];
    questions: Question[];
    asked_questions: Answer[];
}

export interface AuthUser extends WebAppUser {
    registered_now: boolean;
}

export const getAuthProfile = async ():Promise<AuthUser> => {
    try {
        const response = await ax.get(apiUrl + "/current-profile");
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const getProfile = async (telegramId: number):Promise<Profile> => {
    try {
        const response = await ax.get('/profile/'+telegramId);
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const sendProfileQuestion = async (profileId: number, question: string, isAnonymously: boolean): Promise<any> => {
    try {
        const response = await ax.post(`profile/${profileId}/question`, {
            question: question,
            is_anonymous: isAnonymously
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const sendProfileAnswer = async (profileId: number, questionId: number, answer: string): Promise<any> => {
    try {
        const response = await ax.put(`profile/${profileId}/answer`, {
            answer: answer,
            question_id: questionId
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteProfileQuestion = async (profileId: number, questionId: number): Promise<any> => {
    try {
        const response = await ax.delete(`profile/${profileId}/question`, {
            data: {
                question_id: questionId
            }
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const cancelProfileAnswer = async (profileId: number, questionId: number): Promise<any> => {
    try {
        const response = await ax.patch(`profile/${profileId}/answer/cancel`, {
            question_id: questionId
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const saveProfilePhoto = async (photo: File): Promise<any> => {
    const formData = new FormData();
    formData.append('photo', photo);
    try {
        const response = await ax.post('/current-profile/photo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}

export const sendBotImage = async (photo: File): Promise<any> => {
    const formData = new FormData();
    formData.append('photo', photo);
    try {
        const response = await ax.post('/send-bot-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return await response.data;
    } catch (error) {
        throw error;
    }
}
